/**
 * 个人信息
 */


export default {
  path: '/personal',
  name: 'personal',
  component: () => import('@/pages/views/personal/index'),
  meta: {
    title: '个人信息',
    trust: true
  }
}
